
    import { Component, Prop } from 'vue-property-decorator';
    import { Notification, RegisterIssue } from '@/api/model/interfaces';
    import * as Odata from '@/api/odata';
    import NotificationItem from '@/components/common/notification-item.vue';

    @Component
    export default class IssueIssued extends NotificationItem {
        @Prop({ required: true })
        notification!: Notification;

        issue: RegisterIssue | null = null;

        async mounted() {
            this.issue = await Odata.RegisterIssue.setParams({
                expand: [ 'Register' ],
            }).getById(this.notification.EntityId.toString());
            this.link = this.issue.Register ? `/asbuilt/registers/${this.issue.Register.Id}` : null;
        }
    }
